export const useMenu = () => useState('is-menu-open', () => false)
